import { SCheckbox, SDangerSubTitle, SDialogButton, SFilterLabel, SInputLabel, STitleContainer, STitleH3, STitleH4 } from './common/BCommonComponents';
import { Dialog, DialogActions, DialogContent, FormControl, FormControlLabel, Grid, MenuItem, Select, Table, TableBody, TableContainer, TableRow, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { PrestazioneConfigDTO, TipoPrestazione } from './common/Dtos';
import { Order, STableCell, STableHead, STableRow } from './common/ScrivaniaTable';
import AuthContext from './auth/AuthContext';
import { FaDotCircle, FaRegCircle } from 'react-icons/all';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { toast } from 'react-toastify';
import LuxonUtils from '@date-io/luxon';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface InserimentoPrestazioneDialogProps {
	open: boolean;
	onClose: (selected?: PrestazioneConfigDTO) => void;
	tipoContatto: string;
}

export interface PrestazioneHeadCell {
	disablePadding: boolean;
	id: keyof PrestazioneConfigDTO;
	label: string;
	numeric: boolean;
}

export function InserimentoPrestazioneDialog(props: InserimentoPrestazioneDialogProps) {
	const auth = React.useContext(AuthContext);
	const useStyles = makeStyles((theme: Theme) =>
		createStyles({
			formControl: {
				// margin: theme.spacing(1),
				width: '100%',
			},
			selectEmpty: {
				width: '100%',
				margin: '0',
			},
		}),
	);
	const classes = useStyles();
	const codiceFiscalePattern = '^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$';
	const {onClose, open, tipoContatto} = props;
	const prestazioniConfList: PrestazioneConfigDTO[] = auth.state.prestazioniConfList ? [...auth.state.prestazioniConfList] : [];
	const [selected, setSelected] = useState<string>('');
	const [codiceFilter, setCodiceFilter] = useState('');
	const [nomeFilter, setNomeFilter] = useState('');
	const [mostraPreferite, setMostraPreferite] = useState<boolean>(false);
	const [disabilitaInserisciBtn, setDisabilitaInserisciBtn] = useState<boolean>(true);
	const [prestazioniPreferiteList, setPrestazioniPreferiteList] = useState<PrestazioneConfigDTO[]>([]);
	const [prestazioniList, setPrestazioniList] = useState<PrestazioneConfigDTO[]>([]);
	const [codiceFiscalePersona, setCodiceFiscalePersona] = useState('');
	const [nre, setNre] = useState<string>('');
	const [errorNre, setErrorNre] = useState<boolean>(false);
	const [numPrenotazione, setNumPrenotazione] = useState<string>('');
	const [errorCodiceFiscalePersona, setErrorCodiceFiscalePersona] = useState<boolean>(false);
	const [nomePersona, setNomePersona] = useState('');
	const [cognomePersona, setCognomePersona] = useState('');
	const [dataNascitaPersona, setDataNascitaPersona] = useState('');
	const [sessoPersona, setSessoPersona] = useState('');

	const headCells: PrestazioneHeadCell[] = [
		{id: 'id', numeric: false, disablePadding: false, label: ''},
		{id: 'codice', numeric: false, disablePadding: false, label: 'CODICE PRESTAZIONE'},
		{id: 'name', numeric: false, disablePadding: true, label: 'PRESTAZIONE'},
		{id: 'description', numeric: false, disablePadding: true, label: 'DESCRIZIONE'}
	];

	useEffect(() => {
	}, [codiceFilter, nomeFilter, mostraPreferite, selected, prestazioniList]);

	useEffect(() => {
		checkDatiAnagrafici();
	}, [codiceFiscalePersona, nomePersona, cognomePersona, dataNascitaPersona, sessoPersona]);

	useEffect(() => {
		if (open) {
			setNomeFilter('');
			setCodiceFilter('');
			setCodiceFiscalePersona('');
			setNomePersona('');
			setCognomePersona('');
			setDataNascitaPersona('');
			setSessoPersona('');
			setMostraPreferite(false);
			setPrestazioniList([]);
			setSelected('');
			setNre('');
			setNumPrenotazione('');
			getPreferite();
		}
	}, [open]);

	const getPreferite = () => {
		auth.state.axiosInstance?.get('/api/accounts/prestazioni_preferite/' + auth.state.id + '/' + auth.state.puntoServizioLogged?.id)
			.then(res => {
				let preferite: PrestazioneConfigDTO[] = res.data;
				preferite = preferite.filter(prest => prest.type === tipoContatto.toUpperCase());
				setPrestazioniPreferiteList(preferite);
				setPrestazioniList(mergePreferite(preferite));
			})
			.catch(error => {
				toast.error('🛑 Errore durante il recupero delle Prestazioni!');
				console.log(error);
			});
	}

	const mergePreferite = (preferite: PrestazioneConfigDTO[]): PrestazioneConfigDTO[] => {
		const prestazioniTutte = [...prestazioniConfList.filter(prest => prest.type === tipoContatto.toUpperCase())];
		preferite.forEach(pref => {
			const index = prestazioniTutte.findIndex(p => p.id === pref.id);

			if (index >= 0) {
				prestazioniTutte.splice(index, 1);
			}
		});

		let preferiteOnTop = [...preferite];
		preferiteOnTop = preferiteOnTop.concat(prestazioniTutte);
		return preferiteOnTop;
	}

	const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			return;
		}
		setSelected('');
	};

	const handleCheckboxClick = (event: React.MouseEvent<unknown>, prest: PrestazioneConfigDTO) => {
		setSelected(prest.id)
	};

	const isSelected = (id: string) => selected === id;

	const handleClose = () => {
		onClose();
	};

	const handleConfirmation = () => {
		if (selected && selected !== '') {
			const prestazioneConfig = prestazioniList.find(p => p.id === selected);
			if (prestazioneConfig) {
				prestazioneConfig.codiceFiscalePersona = codiceFiscalePersona;
				prestazioneConfig.nomePersona = nomePersona;
				prestazioneConfig.cognomePersona = cognomePersona;
				prestazioneConfig.dataNascitaPersona = dataNascitaPersona;
				prestazioneConfig.sessoPersona = sessoPersona;
				prestazioneConfig.nre = nre;
				prestazioneConfig.numeroPrenotazione = numPrenotazione;
			}
			onClose(prestazioneConfig);
		} else {
			toast.error('🛑 Selezionare la prestazione!');
		}
	};

	const handleCodiceFiscaleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCodiceFiscalePersona(event.target.value.toUpperCase());
	}

	const handleCodiceFiscaleBlur = (event: any) => {
		const codiceFiscale = event.target.value.toUpperCase();
		if (codiceFiscale.match(codiceFiscalePattern)) {
			setErrorCodiceFiscalePersona(false);
		} else {
			setCodiceFiscalePersona('');
			setErrorCodiceFiscalePersona(true);
		}
	}

	const handleCodiceFiscaleKeyDown = (event: any) => {
		if ((event.target as HTMLInputElement).id === 'barcode') {
			const codiceFiscale = event.target.value.toUpperCase();
			if (codiceFiscale.match(codiceFiscalePattern)) {
				setErrorCodiceFiscalePersona(false);
				setCodiceFiscalePersona(event.target.value.toUpperCase());
			} else {
				setCodiceFiscalePersona('');
				setErrorCodiceFiscalePersona(true);
			}
		}
	}

	const handleDataNascitaChange = (date: MaterialUiPickersDate, value?: string | null) => {
		setDataNascitaPersona(date ? date?.toString() : '')
	};

	const handleNomePersonaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNomePersona(event.target.value);
	}

	const handleCognomePersonaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCognomePersona(event.target.value);
	}

	const handleSessoPersonaChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setSessoPersona(event.target.value as string);
	};

	const checkDatiAnagrafici = () => {
		if ((codiceFiscalePersona != null && codiceFiscalePersona.length > 0) ||
			((nomePersona != null && nomePersona.length > 0) &&
				(cognomePersona != null && cognomePersona.length > 0) &&
				(dataNascitaPersona != null && dataNascitaPersona.length > 0) &&
				(sessoPersona != null && sessoPersona.length > 0))) {
			setDisabilitaInserisciBtn(false);
		} else {
			setDisabilitaInserisciBtn(true);
		}
	}

	const handleCodiceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCodiceFilter(event.target.value);
		setSelected('');
	}

	const handleNomeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNomeFilter(event.target.value);
		setSelected('');
	}

	const handleCheckBoxClick = (event: React.ChangeEvent<HTMLInputElement>) => {
		setMostraPreferite(event.target.checked);
		setSelected('');
	}

	const filteredPrestazioni = (): PrestazioneConfigDTO[] => {
		let filtered = [...prestazioniList];

		if (mostraPreferite) {
			filtered = [...prestazioniPreferiteList];
		}

		if (codiceFilter && codiceFilter !== '') {
			filtered = filtered.filter(p => p.codice.toLowerCase().includes(codiceFilter.trim().toLowerCase()));
		}

		if (nomeFilter && nomeFilter !== '') {
			filtered = filtered.filter(p => p.name.toLowerCase().includes(nomeFilter.trim().toLowerCase()));
		}

		return filtered
	}

	const isFlagInserimento = (id: string) => {
		const prest = prestazioniConfList.find(p => p.id === id);
		if (prest) {
			return prest.flagInserimento;
		}
		return false;
	}

	const isFlagModifica = (id: string) => {
		const prest = prestazioniConfList.find(p => p.id === id);
		if (prest) {
			return prest.flagModifica;
		}
		return false;
	}

	const isNewCup = (id: string) => {
		const prest = prestazioniConfList.find(p => p.id === id);
		if (prest) {
			return prest.codice.indexOf("19") === 0;
		}
		return false;
	}

	const handleNreChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNre(event.target.value);
	}

	const handleNreBlur = (event: any) => {
		if (event.target.value && event.target.value.length > 0 && event.target.value.length !== 15) {
			setErrorNre(true);
		} else {
			setErrorNre(false);
		}
	}

	const handleNreKeyDown = (event: any) => {
		if ((event.target as HTMLInputElement).id === 'barcode') {
			if (event.target.value && event.target.value.length > 0 && event.target.value.length !== 15) {
				setErrorNre(true);
			} else {
				setErrorNre(false);
				setNre(event.target.value);
			}
		}
	}

	const handleNumPrenotazioneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setNumPrenotazione(event.target.value);
	}

	return (
		<Dialog
			fullWidth={true}
			maxWidth="lg"
			open={open}>
			<DialogContent>
				<STitleContainer className="mt-0">
					<STitleH3>PRESTAZIONI</STitleH3>
				</STitleContainer>
				<Grid container spacing={0} className="w-100">
					<Grid item xs={3} className="pr-2">
						<TextField
							className="w-100"
							id="codice"
							label="Cerca codice"
							variant="outlined"
							value={codiceFilter}
							onChange={handleCodiceChange}
							InputLabelProps={{shrink: true}}
						/>
					</Grid>
					<Grid item xs={3} className="px-2">
						<TextField
							className="w-100"
							id="prestazione"
							label="Cerca prestazione"
							variant="outlined"
							value={nomeFilter}
							onChange={handleNomeChange}
							InputLabelProps={{shrink: true}}
						/>
					</Grid>
					<Grid item xs={3} className="px-2">
						<FormControlLabel
							control={<SCheckbox onChange={handleCheckBoxClick} name="checkedG"/>}
							label="Solo prestazioni in evidenza"

						/>
					</Grid>
				</Grid>
				<SDangerSubTitle>Procedendo con questa operazione verr&agrave; attivato il timer di tracciamento dell'attivit&agrave;</SDangerSubTitle>
				<TableContainer className="mt-3 max-height-table">
					<Table
						aria-labelledby="tableTitle"
						size={'medium'}
						aria-label="enhanced table"
					>
						<ModalTableHeader
							numSelected={selected.length}
							onSelectAllClick={handleSelectAllClick}
							rowCount={filteredPrestazioni().length}
							headCells={headCells}
							addCheckbox={false}
							bgcolor="secondary"
							sortable={false}
						/>
						<TableBody>
							{filteredPrestazioni()
								.map((row, index) => {
									const isItemSelected = isSelected(row.id);
									const labelId = `enhanced-table-checkbox-${index}`;

									return (
										<STableRow
											hover
											onClick={(event) => handleCheckboxClick(event, row)}
											role="checkbox"
											aria-checked={isItemSelected}
											tabIndex={-1}
											key={row.id}
											selected={isItemSelected}
										>
											<STableCell padding="checkbox">
												<SCheckbox
													checked={isItemSelected}
													icon={<FaRegCircle/>} checkedIcon={<FaDotCircle/>}
													inputProps={{'aria-labelledby': labelId}}
												/>
											</STableCell>
											<STableCell padding="default">{row.codice}</STableCell>
											<STableCell padding="none">{row.name}</STableCell>
											<STableCell padding="none">{row.description ? row.description : '-'}</STableCell>
										</STableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
				{/*{tipoContatto === TipoPrestazione.FRONTOFFICE &&*/}
					<div className="pt-3" hidden={!selected || selected.length === 0}>
						{selected && (isFlagInserimento(selected) || (isFlagModifica(selected) && !isNewCup(selected))) &&
							<React.Fragment>
								<STitleH4>NRE</STitleH4>
								<Grid container spacing={0} className="w-100 mb-3">
									<Grid item xs={3} className="pr-2">
										<TextField
											className="w-100"
											id="nre"
											label="NRE"
											variant="outlined"
											onChange={handleNreChange}
											onBlur={handleNreBlur}
											onKeyDown={handleNreKeyDown}
											InputLabelProps={{shrink: true}}
											error={errorNre}
										/>
									</Grid>
								</Grid>
							</React.Fragment>
						}
						{selected && isFlagModifica(selected) &&
							<React.Fragment>
								<STitleH4>Numero Prenotazione</STitleH4>
								<Grid container spacing={0} className="w-100 mb-3">
									<Grid item xs={3} className="pr-2">
										<TextField
											className="w-100"
											id="nre"
											label="Numero Prenotazione"
											variant="outlined"
											onChange={handleNumPrenotazioneChange}
											InputLabelProps={{shrink: true}}
										/>
									</Grid>
								</Grid>
							</React.Fragment>
						}
						<STitleH4>Dati Anagrafici Persona</STitleH4>
						<Grid container spacing={0} className="w-100 my-2">
							<Grid item xs={3} className="pr-2">
								<TextField
									className="w-100 text-uppercase"
									id="codiceFiscale"
									label="Codice Fiscale"
									variant="outlined"
									onChange={handleCodiceFiscaleChange}
									onBlur={handleCodiceFiscaleBlur}
									onKeyDown={handleCodiceFiscaleKeyDown}
									InputLabelProps={{shrink: true}}
									inputProps={{style: {textTransform: "uppercase"}}}
									error={errorCodiceFiscalePersona}
								/>
							</Grid>
						</Grid>
						{selected.indexOf('7.2.3') < 0 && !isNewCup(selected) &&
							<React.Fragment><SFilterLabel>Oppure</SFilterLabel>
								<Grid container spacing={0} className="w-100">
									<Grid item xs={3} className="pr-2">
										<TextField
											className="w-100"
											id="nomePersona"
											label="Nome"
											variant="outlined"
											onChange={handleNomePersonaChange}
											InputLabelProps={{shrink: true}}
										/>
									</Grid>
									<Grid item xs={3} className="px-2">
										<TextField
											className="w-100"
											id="cognomePersona"
											label="Cognome"
											variant="outlined"
											onChange={handleCognomePersonaChange}
											InputLabelProps={{shrink: true}}
										/>
									</Grid>
									<Grid item xs={3} className="px-2">
										<MuiPickersUtilsProvider utils={LuxonUtils} locale="it-IT">
											<KeyboardDatePicker
												id="dateNascita"
												label="Data di Nascita"
												className="w-100"
												variant="inline"
												inputVariant="outlined"
												InputLabelProps={{shrink: true}}
												onChange={handleDataNascitaChange}
												format="dd/MM/yyyy"
												okLabel={true}
												error={false}
												value={dataNascitaPersona === '' ? null : dataNascitaPersona}
											/>
										</MuiPickersUtilsProvider>
									</Grid>
									<Grid item xs={3} className="px-2">
										<FormControl variant="outlined" className={classes.formControl}>
											<SInputLabel id="sessoPersona">Sesso</SInputLabel>
											<Select
												required
												labelId="sessoPersona"
												id="sessoPersona"
												className={classes.selectEmpty}
												label="Ruolo"
												onChange={handleSessoPersonaChange}
												MenuProps={{
													anchorOrigin: {
														vertical: "bottom",
														horizontal: "left"
													},
													transformOrigin: {
														vertical: "top",
														horizontal: "left"
													},
													getContentAnchorEl: null
												}}
											>
												<MenuItem value={''} key={''}>{'-'}</MenuItem>
												<MenuItem value={'M'} key={'M'}>{'Maschio'}</MenuItem>
												<MenuItem value={'F'} key={'F'}>{'Femmina'}</MenuItem>
											</Select>
										</FormControl>
									</Grid>
								</Grid>
							</React.Fragment>
						}
					</div>
				{/*}*/}
			</DialogContent>
			<DialogActions className="p-4">
				<SDialogButton className="float-right"
											 // disabled={(tipoContatto === TipoPrestazione.FRONTOFFICE && disabilitaInserisciBtn) || (!selected || selected.length === 0)}
											 disabled={disabilitaInserisciBtn}
											 onClick={handleConfirmation}>INSERISCI</SDialogButton>
				<SDialogButton className="float-right" onClick={handleClose}>ANNULLA</SDialogButton>
			</DialogActions>
		</Dialog>
	)
}

interface TableHeaderProps {
	numSelected: number;
	onRequestSort?: (event: React.MouseEvent<unknown>, property: keyof PrestazioneConfigDTO) => void;
	onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
	order?: Order;
	orderBy?: string;
	rowCount: number;
	headCells: PrestazioneHeadCell[];
	addCheckbox: boolean;
	bgcolor: string;
	sortable: boolean;
}

export function ModalTableHeader(props: TableHeaderProps) {
	const {onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, bgcolor, sortable} = props;
	const createSortHandler = (property: keyof PrestazioneConfigDTO) => (event: React.MouseEvent<unknown>) => {
		if (onRequestSort) {
			onRequestSort(event, property);
		}
	};

	return (
		<TableHead>
			<TableRow>
				{props.addCheckbox &&
					<STableHead padding="checkbox" bgcolor={bgcolor}>
						<SCheckbox
							indeterminate={numSelected > 0 && numSelected < rowCount}
							checked={rowCount > 0 && numSelected === rowCount}
							onChange={onSelectAllClick}
							inputProps={{'aria-label': 'select all'}}
						/>
					</STableHead>
				}

				{props.headCells.map((headCell) => (
					<STableHead
						key={headCell.id}
						align={headCell.numeric ? 'right' : 'left'}
						padding={headCell.disablePadding ? 'none' : 'default'}
						sortDirection={orderBy === headCell.id ? order : false}
						bgcolor={bgcolor}
					>
						{(sortable && order && orderBy) ?
							<TableSortLabel
								active={orderBy === headCell.id}
								direction={orderBy === headCell.id ? order : 'asc'}
								onClick={createSortHandler(headCell.id)}
							>
								{headCell.label}
							</TableSortLabel>
							:
							headCell.label
						}

					</STableHead>
				))}
			</TableRow>
		</TableHead>
	);
}
